import { Stack, DialogContent } from '@mui/material'
import { BootstrapDialogTitle } from '../popups/BasicPopup'
import { useAppSelector } from '~/app/hooks'
import { currentTheme } from '~/redux/features'
import { EFDropdownContainerProps } from './EFDropdownContainer.model'
import styles from './EFDropdownContainer.module.scss'
import classNames from 'classnames/bind'

const cx = classNames.bind(styles)
export function EFDropdownContainer(props: EFDropdownContainerProps) {
  const theme = useAppSelector(currentTheme)
  const { children, openPopup, title, onClose } = props
  return (
    <Stack
      direction='column'
      className={cx('dropdown-wrapper', `theme-background ${theme}`)}
      display={openPopup ? 'block' : 'none'}
    >
      <BootstrapDialogTitle
        id='dropdownPopupTitle'
        onClose={onClose}
      >
        <div className={cx('dropdown-title')}>{title}</div>
      </BootstrapDialogTitle>
      <DialogContent sx={{ px: 1, pb: 0 }}>{children}</DialogContent>
    </Stack>
  )
}
